export class PaginatedList<T = unknown> {
    constructor(
        public data: T[],
        public count: number = 0
    ) {
    }
}

export interface BaseObject {
    id?: string
    updatedAt?: string;
    createdAt?: string;
    deletedAt?: string;
}
